var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-st",class:{ 'bg-white': !_vm.nightMode, 'bg-dark': _vm.nightMode }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"parent"},[_c('Publication',{attrs:{"id":"publication","nightMode":_vm.nightMode}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }